import { render, staticRenderFns } from "./depositBackMenu.vue?vue&type=template&id=1b2f8749"
import script from "./depositBackMenu.vue?vue&type=script&lang=js"
export * from "./depositBackMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports